export const formatAPIErrors = result => {
  try {
    if (result.message) {
      return result.message
    }

    let errorMessages = result.detail // default

    if (result.detail.errors) {
      errorMessages = result.detail.errors.reduce(
        (accumulator, currentValue) => {
          return (accumulator += ` - ${currentValue.defaultMessage}<br/>`)
        },
        '',
      )
    } else {
      errorMessages = result.detail.message
    }
    return errorMessages
  } catch (e) {
    return `Error formatting API errors: ${e}`
  }
}
export const errorObjectToString = input => {
  try {
    if (input instanceof Error) {
      return `(Error: ${input.name}\nMessage: ${input.message}\nStack: ${input.stack})`;
    }
    
    if (typeof input === 'string') {
      return `(Error: "${input}")`;
    }
    
    if (typeof input === 'object' && input !== null) {
      try {
        return `(Error: ${JSON.stringify(input, null, 2)})`;
      } catch {
        return `(Error: [Cannot stringify object])`;
      }
    }
  } catch (e) {
    console.error(`(Error: error with error function: converting error object to string: ${e})`)
    return ``
  }
}
